import type { MapBody } from '@shared/mapDefinitions.js';

const def: MapBody<'wikipedia'> = {
  minZoom: 8,
  zIndex: 8,
  attribution: [],
};

export default def;
